import { createChatBotMessage } from "react-chatbot-kit";
import BotAvatar from "./BotAvatar";
import BotMessage from "./BotMessage";
import Options from "./Options";

const config = {
  botName: "CoachBot",
  initialMessages: [
    createChatBotMessage(
      "Hi there, and welcome to CTB talent development services LLP! <br><br> I’m CTB AI, your personal guide to becoming a certified coach."
    ),
    createChatBotMessage("How can I help you today?", {
      widget: "options",
      withAvatar: true,
      payload: {
        options: [
          {
            text: "📚 Know more about CTB",
            nextId: "aboutctb",
          },
          // {
          //   text: "🌱 Learn about Coaching Programs",
          //   nextId: "programs",
          // },
          {
            text: "🎓 Understand ICF Certifications",
            nextId: "certifications",
          },
          {
            text: "🧭 Get a Personalized Recommendation",
            nextId: "recommendation",
          },
          {
            text: "📞 Contact a Program Advisor",
            nextId: "contact",
          },
        ],
      },
    }),
  ],

  customComponents: {
    botAvatar: (props) => <BotAvatar {...props} />,
    botChatMessage: (props) => <BotMessage {...props} />,
  },

  widgets: [
    {
      widgetName: "options",
      widgetFunc: (props) => (
        <Options
          {...props.payload}
          handleOptionClick={props.actionProvider.handleOptionClick}
        />
      ),
    },
  ],
};

export default config;